import React from 'react';
import './EmptyState.css';

export default function EmptyState({ title = 'No items yet', description }) {
  return (
    <div className="empty-state">
      <div className="title">{title}</div>
      {description && <div className="desc">{description}</div>}
    </div>
  );
}
